import styled from '@benzinga/themetron';
import { TimeNotifyModeBtn } from './buttonV2';
import React from 'react';

export type BtnObject = {
  title: string;
  value: string;
  selected: string;
  onClick: (event: React.MouseEvent<HTMLButtonElement>) => void;
};

interface RadioGroupRowProps {
  objects: BtnObject[];
}

export const RadioGroupRow: React.FC<RadioGroupRowProps> = (props: RadioGroupRowProps) => {
  const [anyBtnHovered, setAnyBtnHovered] = React.useState({ isHovered: false, value: '' });

  const handleBtnHover = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnyBtnHovered({ isHovered: true, value: (event.target as HTMLButtonElement).getAttribute('value') as string });
  };

  const handleBtnLeave = () => {
    setAnyBtnHovered({ isHovered: false, value: '' });
  };

  const renderRadioBtns = (btnArr: BtnObject[]): React.ReactElement => {
    return (
      <BtnListWrapper id="btnListWrapperId" length={btnArr.length}>
        {btnArr.map((btn, index) => (
          <Row key={btn.value}>
            <Btn
              anyBtnHovered={anyBtnHovered}
              onClick={btn.onClick}
              onMouseEnter={handleBtnHover}
              onMouseLeave={handleBtnLeave}
              selected={btn.selected}
              title={btn.title}
              value={btn.value}
            />
            {index < btnArr.length - 1 && <Divider />}
          </Row>
        ))}
      </BtnListWrapper>
    );
  };

  return <Wrapper>{renderRadioBtns(props.objects)}</Wrapper>;
};

const BtnListWrapper = styled.div<{ length: number }>`
  display: grid;
  width: 100%;
  grid-template-columns: repeat(${props => props.length}, 1fr);
  grid-auto-rows: 1fr;
  gap: 0px;
`;
const Btn = styled(TimeNotifyModeBtn)`
  border-radius: none;
  width: 100%;
  height: auto;
`;
const Divider = styled.div`
  width: 2px;
  border-right: 2px ${props => props.theme.colors.actionFocus} solid;
  height: 100%;
`;
const Wrapper = styled.div`
  display: flex;
  flex-grow: 1;
`;
const Row = styled.div`
  display: flex;
  flex-direction: row;
`;
